import { createId } from '@/features/chat/chatIds'
import { registerArtifactPayload } from '@/features/documentPreview/artifactPayloadStore'
import { buildDemoPayloadForKind } from './generatedArtifactDemoPayloads.js'

/**
 * @param {{
 *   kind: import('@/features/documentPreview/documentPreviewTypes.js').ArtifactKind,
 *   fileName: string,
 *   description: string,
 *   leadLine: string,
 *   displayTitle: string,
 * }} details
 * @returns {{ blocks: Array<Record<string, unknown>>, artifactId: string }}
 */
export function buildGeneratedArtifactAssistantBlocks(details) {
  const artifactId = createId()
  const payload = buildDemoPayloadForKind(details.kind, details.displayTitle)

  registerArtifactPayload({
    artifactId,
    kind: details.kind,
    fileName: details.fileName,
    description: details.description,
    payload,
  })

  return {
    artifactId,
    blocks: [
      { type: 'markdown', content: details.leadLine },
      {
        type: 'fileArtifact',
        fileName: details.fileName,
        description: details.description,
        artifactKind: details.kind,
        artifactId,
      },
    ],
  }
}
